import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import Text from '../../atoms/Text/Text'
import X from '../../../images/blackx.svg'
import linkedinLogo from '../../../images/linkedinLogo.svg'
import ReviewedCheck from '../../../images/reviewed_check'
import down from '../../../images/downpath.svg'
import shield from '../../../images/shield.svg'
import cash from '../../../images/cashgreen.svg'
import media from 'styled-media-query'
import IconInfo from '../../IconInfo/IconInfo'
import { removeTags } from '../../../utils/removeTags'
const Style = styled.div`
  position: fixed;
  display: inline-block;
  bottom: 0px;
  z-index: 9999;
  width: 100vw;
  box-shadow: rgba(0, 0, 0, 0.3) 0 2px 10px;
  .overlay {
    cursor: pointer;
    z-index: -1;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    right: 0;
    top: 0;
  }
  .cancel-container {
    height: 30px;
    margin: 10px auto 0px auto;
  }

  .cancel-button {
    cursor: pointer;
    width: 20px;
    float: right;
  }
  .modal-content {
    height: fit-content;
    z-index: 9999;
    padding: 20px;
    /* height: 225px; */
    background-color: #ffffff;
  }

  .tooltip-subtitle {
    margin: 0 0 10px 0;
    color: #6d6d6d;
    font-size: 16px;
  }
  .reviewer-subtitle {
    width: 100%;
    margin-top: 10px;
    margin-left: 15px;
  }

  .modal-body {
    font-size: 14px;
    margin: 5px auto;
  }

  .f-text {
    font-weight: 600;
    color: #31279b;
  }
  .author-title {
    display: inline-block;
    font-weight: 600;
    color: #31279b;
  }

  .f-link {
    text-decoration: none;
  }
`
const TooltipModal = (props) => {
  if (!props.show) return null
  return ReactDOM.createPortal(
    <Style>
      <div className="modal-content">
        <div className="cancel-container">
          <p>{props.tooltipTitle}</p>
          <img
            src={X}
            className="cancel-button"
          />
        </div>
        {props.isReviewer && (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '50px', display: 'inline-block' }}>
              <img
                src={`https://res.cloudinary.com/rehabpath/image/upload/v1655327781/${props.reviewerSlug}-circular-headshot.jpg`}
                alt=""
                style={{
                  borderRadius: '50%',
                  width: '100%'
                }}
              />
            </div>
            {props.tooltipSubtitle && (
              <div className="tooltip-subtitle reviewer-subtitle">
                {props.isReviewer && (
                  <>
                    {props.tooltipTitle && (
                      <div
                        style={{ marginBottom: '20px', marginLeft: '15px' }}
                        className="f-text"
                      >
                        <p>{props.tooltipTitle}</p>
                      </div>
                    )}
                    <div
                      style={{
                        color: '#E55925',
                        position: 'relative',
                        bottom: '12px',
                        display: 'inline-block',
                        width: '100%'
                      }}
                    >
                      <ReviewedCheck />
                      &nbsp;
                      <p
                        style={{
                          display: 'inline-block',
                          width: '75%',
                          fontSize: '14px',
                          color: '#6d6d6d'
                        }}
                      >
                        {props.tooltipSubtitle}
                      </p>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
        {props.tooltipSubtitle && props.isAuthor && (
          <div className="tooltip-subtitle">
            <p style={{ display: 'inline-block' }}>{props.tooltipSubtitle}</p>
          </div>
        )}
        <div style={{ width: '20px' }}>
          {props.authorLinkedin && (
            <a
              href={props.authorLinkedin}
              target="_blank"
              rel="noreferrer"
            >
              <img
                style={{
                  display: 'inline-block',
                  filter:
                    'invert(48%) sepia(5%) saturate(1644%) hue-rotate(140deg) brightness(90%) contrast(96%)'
                }}
                src={linkedinLogo}
                alt=""
              />
            </a>
          )}
        </div>
        {props.tooltipBodyText && !props.showListings && (
          <div
            dangerouslySetInnerHTML={{ __html: props.tooltipBodyText }}
            className="modal-body"
          />
        )}
        {props.tooltipBodyText && props.showListings && (
          <div className="modal-body pb-2 pt-4">
            <span className="modal-text mx-auto mt-[5px] text-sm">
              {removeTags(props.tooltipBodyText).trim()}
              {props.footerLink && (
                <span>
                  {'..'}
                  <a
                    href={props.footerLink}
                    className="learn-more text-sm font-semibold underline"
                  >
                    {props.footerLinkText}
                  </a>{' '}
                </span>
              )}
            </span>
          </div>
        )}
        {props.footerLink && !props.showListings && (
          <div className="f-text">
            <p>
              <a
                target={
                  props.footerLinkText === 'Claimed' ||
                  props.footerLinkText === 'Verified'
                    ? ''
                    : '_blank'
                }
                className="f-link"
                href={`${props.footerLink}`}
              >
                {props.footerLinkText}
              </a>
            </p>
          </div>
        )}
        {props.centerTipLink && props.showListings && (
          <div className="center-link font-semibold">
            <a
              className="center-link-text pointer pt-4 underline"
              href={`${props.centerTipLink}`}
            >
              {props.centerTipLinkText}
            </a>
          </div>
        )}
      </div>
      <div className="overlay" />
    </Style>,
    document.body
  )
}

const TooltipStyle = styled.div`
  padding: ${(prop) => (prop.addPadding ? ' 5px 10px' : '0px')};
  display: inline-block;
  ${(prop) => prop.addPadding && 'background: rgb(241, 244, 248);'}
  ${media.lessThan('medium')`
    font-weight: ${(prop) => (prop.adDisclaimer ? '400' : '600')};
      `}
  .cards-button-text {
    background: white;
    font-weight: ${(prop) => (prop.profile ? '400' : '500')};
    ${media.lessThan('medium')`
      font-weight: 500;

      `}
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0.15px;
    color: #4d657f;
    display: flex;
    align-items: center;
  }
  .down {
    height: 5px;
    width: 8px;
    margin-left: 6px;
  }
  .shield {
    height: 16px;
    width: 16px;
    margin-right: 8px;
  }
`

const MobileTooltip = (props) => {
  const [show, setShow] = useState(false)
  const modalRef = useRef(null)

  // checking to see if user clicks outside of modal
  useEffect(() => {
    document.querySelector('html').style.overflow = show ? 'hidden' : null

    const handleClickOutside = (event) => {
      // if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShow(false)
      // }
    }
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [show])

  const setHidden = () => {
    setShow(true)
  }

  return (
    <TooltipStyle
      onClick={setHidden}
      className={!props.cards && 'tooltip ' + props.className}
      addPadding={props.addPadding}
      adDisclaimer={props.adDisclaimer}
      profile={props.profile}
    >
      <div
        style={{ display: 'flex' }}
        className="trigger-elm"
      >
        {props.triggerImage && (
          <img
            src={props.triggerImage}
            className="text-gray-900"
            alt=""
            style={{
              margin: '-2px 3px',
              cursor: 'pointer'
            }}
          />
        )}
        {props.blog && props.isAuthor && (
          <span
            css={`
              display: inline-block;
              color: #31279b;
              fontweight: 700;
              textdecoration: none;
            `}
            className="author-reviewer-text"
          >
            {props.authorName}
          </span>
        )}
        {props.blog && props.isReviewer && (
          <span
            css={`
              display: inline-block;
              color: #31279b;
              fontweight: 700;
              textdecoration: none;
            `}
            className="author-reviewer-text"
          >
            {props.reviewerName}
          </span>
        )}
        {props.claimedStatus && (
          <img
            className="trigger-image"
            src={props.triggerImage}
            alt=""
            style={{
              margin: '-2px 3px',
              cursor: 'pointer'
            }}
          />
        )}
        {props.treatmentButton && (
          <Text
            className="treatment-button-text"
            style={{ borderBottom: props.borderBottom }}
          >
            {props.tooltipTitle}
          </Text>
        )}
        {props.adDisclaimer && (
          <div className="flex items-center gap-1 text-sm text-gray-900">
            <div>Ads</div>
            <div>
              <IconInfo size="sm" />
            </div>
          </div>
        )}
        {props.cards && (
          <p className="cards-button-text">
            <img
              src={props.cash ? cash : shield}
              className="shield"
            />
            {props.triggerText}
            <img
              src={down}
              className="down"
            />
          </p>
        )}
        {props.triggerText && props.triggerImage && (
          <Text
            style={{
              display: 'inline-block',
              fontWeight: '600',
              color:
                props.triggerText == 'Claimed'
                  ? '#677d95'
                  : props.triggerText == 'Unclaimed'
                  ? '#677D95'
                  : '#38A0DB'
            }}
            className="claimed-status-text"
          >
            {props.triggerText}
          </Text>
        )}
      </div>
      <div ref={modalRef}>
        <TooltipModal
          {...props}
          show={show}
        />
      </div>
    </TooltipStyle>
  )
}

export default MobileTooltip
